module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "container absence-view absence-calendar"
  }, [(this.employees.length > 0) ? _c('div', {
    staticClass: "month"
  }, [_c('ul', [_c('button', {
    staticClass: "prev btn btn-change",
    on: {
      "click": function () { return _vm.changeMonth(-1); }
    }
  }, [_vm._v("❮")]), _vm._v(" "), _c('button', {
    staticClass: "next btn btn-change",
    on: {
      "click": function () { return _vm.changeMonth(1); }
    }
  }, [_vm._v("❯")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "color-blue"
  }, [_vm._v(_vm._s(_vm.monthName))]), _vm._v(" "), _c('span', {
    staticClass: "color-grey font-18"
  }, [_vm._v(_vm._s(_vm.year))]), _vm._v(" "), _c('SelectEmployees', {
    staticClass: "select-employee",
    attrs: {
      "defaultEmployee": "wszyscy",
      "showLabel": false,
      "prefetchedEmployees": this.employees
    },
    on: {
      "remote_user": _vm.changeUser
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "rows-tables"
  }, [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, _vm._l((_vm.weeks), function(week) {
    return _c('table', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.weeks),
        expression: "weeks"
      }],
      key: week.id,
      staticClass: "table table-border table-week-days"
    }, [_c('thead', {
      staticClass: "thead-pink bg-all-days"
    }, [_c('tr', _vm._l((week.dates), function(date) {
      return _c('DayCalendar', {
        key: date.id,
        attrs: {
          "resetFlag": _vm.resetFlag,
          "date": _vm.formatDateToString(date),
          "isAnotherMonth": date.month() !== week.month,
          "disabled": date <= _vm.today || _vm.foreignUser,
          "absence": _vm.hasAbsence(date)
        },
        on: {
          "add": _vm.add,
          "remove": _vm.remove
        }
      })
    }), 1)]), _vm._v(" "), _c('tbody', [_vm._l((week.rows), function(row) {
      return _c('tr', {
        key: row.id,
        staticClass: "absence-cards"
      }, [_vm._l((row.absences), function(absence) {
        return [(absence.username) ? _c('td', {
          key: absence.id,
          attrs: {
            "colspan": absence.span
          }
        }, [(absence.username) ? _c('div', {
          staticClass: "absence-card-box",
          style: ({
            'border-color': _vm.getBackgroundColor(absence.remote_user)
          })
        }, [_vm._v(_vm._s(absence.username) + "\n              ")]) : _vm._e()]) : _c('td', {
          key: absence.id,
          attrs: {
            "colspan": absence.span
          }
        })]
      })], 2)
    }), _vm._v(" "), (week.dates.length && !week.rows.length) ? _c('tr', {
      staticClass: "absence-cards"
    }, [_c('td', {
      attrs: {
        "colspan": 5
      }
    })]) : _vm._e()], 2)])
  }), 0)], 1), _vm._v(" "), (_vm.addedToMake.length + _vm.addedToRemove.length > 0) ? _c('button', {
    staticClass: "btn btn-orange btn-default btn-xs btn-confirm",
    attrs: {
      "id": "confirm",
      "type": "button"
    },
    on: {
      "click": _vm.confirmChanges
    }
  }, [_c('span', [_vm._v("Zatwierdź zmiany")]), _vm._m(0)]) : _vm._e(), _vm._v(" "), _c('Vacation', {
    ref: "vacation",
    attrs: {
      "myVacationRequest": _vm.myVacationRequests
    },
    on: {
      "refreshMyRequest": _vm.getMyVacation,
      "refreshCalendar": _vm.getAbsences
    }
  })], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("done")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-12f77000!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/ia/AbsenceCalendar.vue
// module id = 1084
// module chunks = 0